import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@mui/utils';
import {
  Box,
  Checkbox,
  TableRow,
  TableCell,
  TableHead,
  TableSortLabel,
  tableCellClasses
} from '@mui/material';
// styling
import { StyledTableCell } from '../../../pages/Global/Styling';
// ----------------------------------------------------------------------

UserListHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func
};

export default function UserListHead({
  order,
  orderBy,
  rowCount,
  headLabel,
  numSelected,
  onRequestSort,
  onSelectAllClick,
  isCheckBox,
  disableBoxTrue,
  disableBoxFalse,
  parent
}) {
  const createSortHandler = (property) => {
    onRequestSort({}, property);
  };
  return (
    <TableHead sx={{ bgcolor: '#ffffff' }}>
      <TableRow>
        {isCheckBox && (
          <StyledTableCell padding="checkbox" sx={{ pl: 2.5 }}>
            <Checkbox
              className={
                disableBoxTrue &&
                disableBoxFalse &&
                disableBoxTrue.length > 0 &&
                disableBoxFalse.length === 0
                  ? 'disabledDocument'
                  : 'enabledDocument'
              }
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              sx={{
                color: '#cbd5e1',
                '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: '#0284c7' }
              }}
            />
          </StyledTableCell>
        )}
        {headLabel.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align={headCell.align || (headCell.alignRight ? 'right' : 'left')}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              fontSize: '11.5px',
              fontWeight: 700,
              color: '#64748b',
              bgcolor: '#ffffff',
              borderBottom: '1px solid #e2e8f0',
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
              py: 1.5,
              px: 1.75,
              ...(parent === 'reports' ? { minWidth: '150px' } : {}),
              ...(((parent === 'sales' && headCell.id === 'leadId') ||
                headCell.label === 'Policy ID' ||
                (parent === 'aggrement' && headCell.label === 'Bank')) && {
                pl: 3
              }),
              ...(headCell.alignRight && { pr: 3 })
            }}
          >
            <TableSortLabel
              hideSortIcon
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={() => createSortHandler(headCell.id)}
              sx={{
                fontSize: '11.5px',
                fontWeight: 700,
                color: '#64748b !important',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                '&:hover': { color: '#0284c7 !important' },
                '&.Mui-active': { color: '#0284c7 !important' }
              }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box sx={{ ...visuallyHidden }}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
